import { Box, Typography } from "@mui/material";
import React from "react";
import Button from "../Button";

const TablePagination = ({ page, count, onNextClick, onPrevClick, nextId, totalCount }) => {
  const start = (page - 1) * 10 + 1;
  let end = (page) * 10 > totalCount ? totalCount : (page) * 10

  const getPage = () => {
    return `${start} - ${end} of ${totalCount}`
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        marginTop: "1rem",
        gap: "1rem",
      }}
    >
      <Button
        disabled={page === 1}
        onClick={onPrevClick}
        label="Prev"
        style={{
          width: "60px",
          height: "32px",
        }}
      />
      <Typography>
        {getPage()}
      </Typography>
      <Button
        disabled={totalCount === end}
        onClick={onNextClick}
        label="Next"
        style={{
          width: "60px",
          height: "32px",
        }}
      />
    </Box>
  );
};

export default TablePagination;
